module.exports = __webpack_public_path__ + "img/variedadpracticas.88ec1ab3.png";